import React, { useState } from 'react';

function LargestFleetCard({ airline, fleetSize, logoPath, stats = {} }) {
  const [logoError, setLogoError] = useState(false);

  return (
    <div className="largest-fleet-card">
      <div className="largest-fleet-logo-container">
        {logoError ? (
          // Fallback to text if logo fails to load
          <div className="largest-fleet-logo-placeholder">
            <span className="logo-text">{airline}</span>
          </div>
        ) : (
          <img
            src={logoPath}
            alt={`${airline} logo`}
            className="largest-fleet-logo"
            onError={() => setLogoError(true)}
          />
        )}
      </div>

      <div className="largest-fleet-stats">
        <div className="stat-item">
          <span className="stat-label">Largest Fleet Operator</span>
          <span className="stat-value">{airline}</span>
        </div>

        {fleetSize && (
          <div className="stat-item">
            <span className="stat-label">Fleet Size</span>
            <span className="stat-value">{fleetSize}</span>
          </div>
        )}

        {/* Render additional stats if provided */}
        {Object.entries(stats).map(([key, value]) => (
          <div key={key} className="stat-item">
            <span className="stat-label">{key}</span>
            <span className="stat-value">{value}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default LargestFleetCard;
